var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"base-button",attrs:{"for":_vm.refId,"id":"label"}},[_c('base-btn',{attrs:{"type":_vm.toRemove ? 'danger': 'secondary'},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }